export const BASE_API_FORM_TYPE_INT = 'int';
export const BASE_API_FORM_TYPE_FLOAT = 'float';
export const BASE_API_FORM_TYPE_STRING = 'string';
export const BASE_API_FORM_TYPE_DATE = 'date';
export const BASE_API_FORM_TYPE_DATE_MONTH = 'dateMonth';
export const BASE_API_FORM_TYPE_TIME = 'time';
export const BASE_API_FORM_TYPE_HTML = 'html';
export const BASE_API_FORM_TYPE_FILE = 'file';
export const BASE_API_FORM_TYPE_JSON = 'json';
export const BASE_API_FORM_TYPE_FILE_ARRAY = 'fileArray';
